export const MAX_LENGTH_AGE = 3;
export const MIN_PLAYABLEAGE = 1;
export const MAX_PLAYABLEAGE = 120;
export const MAX_PLAYABLEAGE_MONTHS = 36;
